module.exports = __webpack_public_path__ + "static/37-Broadpeak-851d3dc391944d8aa49474406b09f8af.png";